import React from 'react';
import { HashRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import './App.scss';
import AppRouter from '@layouts/AppRouter';
import ErrorBoundary from './ErrorBoundary';

function App() {
  return (
    <div className="App">
      <HashRouter>
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </HashRouter>
      <ToastContainer
        style={{ width: '450px' }}
        position="bottom-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default React.memo(App);
